import { render } from "./DiscussionProfileComponent.vue?vue&type=template&id=fe3ffb8e"
import script from "./DiscussionProfileComponent.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./DiscussionProfileComponent.vue?vue&type=script&charset=utf-8&lang=js"

import "./DiscussionProfileComponent.vue?vue&type=style&index=0&id=fe3ffb8e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__